export const ACC_LIST_BTN = 'Список аккаунтов';
export const INSTITUTIONS_LIST = 'Список учреждений';
export const SECTIONS = 'Разделы и подразделы';
export const EDIT_BLANK = 'Редактировать';
export const BLOCK_BLANC = 'Блокировать';
export const ADD_ACC_BTN = 'Добавить аккаунт';
export const ADD_ACC = 'Добавление аккаунта сотрудника';
export const MODAL_ACC_TEXT = 'Заполните все поля и отправьте приглашение. Приглашение придет на указанную почту';
export const FAMILY_NAME = 'Фамилия';
export const NAME = 'Имя';
export const SURNAME = 'Отчество';
export const EMAIL = 'Email';
export const ROLE = 'Роль сотрудника';
export const ENTER_FAMILY_NAME = 'Введите фамилию специалиста';
export const ENTER_NAME = 'Введите имя специалиста';
export const ENTER_SURNAME = 'Введите отчество специалиста';
export const ENTER_EMAIL = 'Введите email специалиста';
export const ENTER_ROLE = 'Выберите роль из списка';
export const ADMIN = 'Администратор';
export const MANAGER = 'Менеджер';
export const CHIEF = 'Руководитель';
export const SPECIALIST = 'Специалист';
export const CANCEL = 'Отменить';
export const SENT_INVITATION = 'Отправить приглашение';
export const EDIT_ACC = 'Редактирование аккаунта сотрудника';
export const SAVE = 'Сохранить';
export const BLOCK = 'Заблокировать';
export const BLOCK_ACC = 'Подтверждение блокировки';
export const BLOCK_QUESTION = 'Вы уверены, что хотите заблокировать данный аккаунт сотрудника?';
export const ENTER_ESTABLISHMENT_NAME = 'Введите название учреждения';
export const ESTABLISHMENT = 'Учреждение';
export const ADD_ESTABLISHMENT_BTN = 'Добавить учреждение';
export const ADD_ESTABLISHMENT = 'Добавление учреждения';
export const EDIT_ACC_ESTABLISHMENT = 'Редактирование учреждения';
export const SECTION = 'Раздел';
export const SUBSECTION = 'Подраздел';
export const ADD_DESCRIPTION = 'Добавить раздел';
export const CANCEL_VTN = 'Отмена';
export const DELETE_SECTION = 'Удалить раздел';
export const DELETE_SUBSECTION = 'Удалить подраздел';
export const CONFIRMATION_DELETE = 'Подтверждение удаления';
export const DELETE_QUESTION = 'Вы уверены, что хотите удалить данный раздел?';
export const DELETE = 'Да,Удалить';
export const ADD_SUBSECTION = 'Добавить подраздел';
export const UNBLOCK_ACC = 'Подтверждение разблокировки';
export const UNBLOCK_QUESTION = 'Вы уверены, что хотите разблокировать данный аккаунт сотрудника?';
export const UNBLOCK = 'Разблокировать';
export const UNBLOCK_BLANC = 'Разблокировать';
export const NO_DATA_ORG = 'Учреждения не найдены';
export const NO_DATA_ORG_INFO = 'Попробуйте искать по другому или сбросьте поиск';
export const RESET_SEARCH = 'Сбросить поиск';
export const NO_DATA_USERS = 'Аккаунт не найден';
